import { css } from '@emotion/css';
import { ColorConstant } from 'src/styles';

export const value = css`
  color: ${ColorConstant.BRAND6};
`;
